import PopupInformation from "shared/components/popups/PopupInformation.js";

const PopupInformationResultProbability = ({}) => {
  return (
    <PopupInformation
      trigger={<i class="bi bi-info-circle-fill text-main cursor-pointer ms-1"></i>}
      title={"What is result probability?"}
      content={
        <div>
          <p>
            <strong>Result Probability</strong> shows the estimated probability of each match result based on historical
            results from similar matchups.
          </p>

          <p>
            The calculation considers both the <strong>goal difference</strong> and the <strong>OVR difference</strong>{" "}
            between the teams, using historical matches with similar characteristics.
          </p>

          <p>Each result is displayed as a percentage:</p>

          <ul>
            <li>
              <strong>Win</strong>: Probability of winning the match
            </li>
            <li>
              <strong>Draw</strong>: Probability of drawing the match
            </li>
            <li>
              <strong>Loss</strong>: Probability of losing the match
            </li>
          </ul>

          <p>
            The probabilities are based on historical data, so they should be considered an estimate rather than a
            prediction of the exact match outcome.
          </p>
        </div>
      }
    />
  );
};

export default PopupInformationResultProbability;
